<template>
  <section class="personal-information-picker">
    <div class="header">
      <h5>{{ $t('step4.address.informations') }}</h5>
      <div class="header-action">
        <a @click="openModal(null)" class="total-btn">
          {{$t('profile.addresses.modal.title')}}
        </a>
      </div>
    </div>
    <div class="personal-information grid-info">
      <div class="info-column">
        <h6>{{$t('step4.address.contactInfo')}}</h6>
        <div class="name">
          {{firstName}} <span>{{lastName}}</span>
        </div>
        <form>
          <div class="adress">
            <email-input v-model="email" v-required v-error="emailHasError"
                         :placeholder="$t('register.info.email')" :value="email"
                         ref="inputEmail" :clean-errors-on-input="true" :use-dynamic-errors="true"
                         :use-mail-checker="true"/>
          </div>
          <div class="telephone">
            <vue-phone-number-input :translations="phoneLocale" :value="defaultPhone" @update="phoneUpdate"
                                    ref="phoneInput"/>
          </div>
        </form>
      </div>
      <div class="info-column">
        <h6>{{$t('step4.address.paymentInfo')}}</h6>
        <select name="address" id="title" class="form-control" v-model="id_select" ref="selectInput">
          <option v-for="(address, index) in addresses" :value="address.id">{{address.description}}</option>
        </select>
        <div class="address">
          <div v-if="selectedAddress">
            <template v-if="selectedAddress.society_name">{{ selectedAddress.society_name }}<br></template>
            <template v-if="!selectedAddress.society_name">{{firstName}} <span>{{lastName}}</span><br></template>
            {{selectedAddress.address}} <br>
            <template v-if="selectedAddress.additional">{{selectedAddress.additional}} <br></template>
            {{selectedAddress.zip}} - {{selectedAddress.city}} {{selectedAddress.country.alpha2}}
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import Loader from '../../../components/loader.component';
  import CheckboxInput from '../../../components/checkbox-input';
  import TextInput from '../../../components/text-input';
  import { parsePhoneNumberFromString } from 'libphonenumber-js';
  import { mapState } from 'vuex';
  import { withComputeError } from '../../../components/mixins/input-wrapper.mixin';
  import EmailInput from '../../../components/email-input';

  export default {
    mixins: [withComputeError],
    name: 'step4-personal-informations',
    components: { EmailInput, TextInput, CheckboxInput, Loader },
    props: {
      bookingId: {
        required: true,
      }
    },
    data() {
      return {
        id_select: null,
        email: this.$store.state.client.client.email,
        firstName: this.$store.state.client.client.firstName,
        lastName: this.$store.state.client.client.lastName,
        phoneLocale: {
          countrySelectorLabel: this.$t('profile.info.phone.countrySelectorLabel'),
          countrySelectorError: this.$t('profile.info.phone.countrySelectorError'),
          phoneNumberLabel: this.$t('profile.info.phone.phoneNumberLabel'),
          example: this.$t('profile.info.phone.example'),
        },
        phone: '',
        defaultPhone: '',
        defaultCountry: '',
        hasPhoneError: false,
        phoneError: '',
        emailHasError: false,
      };
    },
    watch: {
      id_select(v) {
        if (v === null) return;
        this.id_select = parseInt(v);
        this.handleInputChange();
      },
      phone (v) {
        this.handleInputChange();
      },
      email (v) {
        this.handleInputChange();
      },
      firstName (v) {
        this.handleInputChange();
      },
      lastName (v) {
        this.handleInputChange();
      }
    },
    computed: {

      hasError() {
        return this.hasPhoneError || this.emailHasError;
      },
      selectedAddress() {
        if (this.id_select) {
          return this.addresses.filter(a => a.id === this.id_select)[0] || null;
        }
        return null;
      },
      ...mapState({
        user: s => s.client.client,
        loading: s => s.clientAddresses.loading,
        addresses: s => s.clientAddresses.addresses.sort((a, b) => (a.is_main < b.is_main ? 1 : -1)),
      }),
    },
    methods: {
      handleInputChange () {
        const keys = ['phone', 'email', 'firstName', 'lastName'];
        for (const k of keys) {
          if (!this[k] || this[k] === '') {
            this.$store.commit('shoppingCart/booking/personal/SET_HAS_INFORMATION', false);
            return;
          }
        }
        this.$store.commit('shoppingCart/booking/personal/SET_HAS_INFORMATION', true);
        this.$store.commit('shoppingCart/booking/personal/SET_DATA_ADDRESS', parseInt(this.id_select));
        this.$store.commit('shoppingCart/booking/personal/SET_DATA_INFOS', {
          phone: this.phone,
          email: this.email,
          firstName: this.firstName,
          lastName: this.lastName
        })
      },
      async openModal(id) {
        this.$store.commit('addressesModal/SET_ADDRESS_ID', id);
        window.dispatchEvent(new Event('app:addresses-modal.open'));
      },
      phoneUpdate(v) {
        this.defaultPhone = v.formatNational || v.phoneNumber;
        if (v.isValid) {
          this.phone = v.e164;
          this.hasPhoneError = false;
        } else {
          this.hasPhoneError = true;
          this.phone = '';
        }
      },

      phoneCheck(e) {
        if (this.phone) {
          return true;
        }
        if (this.phone === '') {
          this.hasPhoneError = true;
          this.phoneError = this.$t('field_is_required');
        }
        e.preventDefault();
      },

      send(e) {
        this.phoneCheck(e);
        this.computeErrors();
      },
    },
    async mounted() {
      await this.$store.dispatch('clientAddresses/fetch');
      await this.$store.dispatch('countries/init');
      // gerer les erreurs (IF)
      if (this.addresses.length > 0) {
        this.$refs.selectInput.value = this.addresses[0].id;
        this.id_select = this.$refs.selectInput.value;
      }


      const inputPhone = this.$store.state.client.client.phone;
      const phoneParser = parsePhoneNumberFromString(this.$store.state.client.client.phone);
      this.defaultPhone = inputPhone.replace(`+${phoneParser.countryCallingCode}`, '0');
      this.defaultCountry = phoneParser.metadata.country_calling_codes[phoneParser.countryCallingCode][0];
      this.$refs.phoneInput.emitValues({ countryCode: this.defaultCountry, phoneNumber: this.defaultPhone });
      this.$refs.inputEmail.updateValue(this.email);
    },

  };
</script>




// WEBPACK FOOTER //
// src/pages/tunnel/step4-multi/step4-personal-informations.vue